import { render } from "./operat.vue?vue&type=template&id=44e067b8&ts=true"
import script from "./operat.vue?vue&type=script&lang=ts"
export * from "./operat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__